/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";
export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'hidden',
    profile: {
        p_name_col_name: false,
        p_description_col_name: false,
        locale: 'nl-nl',
        currency: 'EUR',
        taxonomy_builder_only_n_cats: true,
        allowIncompleteTaxonomy: true,
        parentSupplierAltName: 'Normalized Supplier',

        /*@formatter:off*/
        categorizationReviewSubRowRelationData: [{
            relation: "part",
            columns: [
                {db_column: 'p_inv_line_description', colSpec: {txt: 'Text', columnFieldId: 'p_inv_line_description'}},
            ]
        }],
        /*@formatter:on*/
        enableProcChat: true,
        enableChatOnSample: true,
        enableExploreCategoriesOnSample: true,
        enableAdvancedDashboardOnSample: true,
        enableSpendConcentrationOnSample: true,
        enableSavingInitiativeTracker: true,

        supplierStandAloneFilter: '(default)', // See CAT-3590 before changing this
    },
}
